import React from "react"

function PaperStack({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18 11.4L8.3 14.5L18 18L27.7 14.5L18 11.4Z" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M8.3 17.3L18 20.8L27.7 17.3" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M8.3 19.4L18 22.9L27.7 19.4" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M8.3 21.5L18 25L27.7 21.5" stroke="#003E4C" strokeWidth="0.75" />
    </svg>
  )
}
export default PaperStack
